import React from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyKind, fetchKinds } from "../../../../actions/community/kindsActions";
import { KindInterface, setEditId } from "../../../../store/community/kindsSlice";

import { message } from "antd";
import ListVertical from "../../../../componets/ListVertical";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";

const _ListItem = ({ kind, activeId }: { kind: KindInterface | undefined; activeId?: number }) => {
  const dispatch = useAppDispatch();
  const options = [
    <ButtonEdit key={`edit-${kind?.id}`} onClick={onClickEdit} />,
    <ButtonDestroy key={`destroy-${kind?.id}`} onClick={onClickDestroy} />
  ]

  function onClickEdit() {
    if (kind) {
      dispatch(setEditId(kind.id));
    }
  }

  function onClickDestroy() {
    if (kind) {
      handleDestroy(kind.id).catch(console.error);
    }
  }

  async function handleDestroy(id: any) {
    const resultAction = await dispatch(destroyKind(id));

    if (!kind) {
      return;
    }

    if (destroyKind.fulfilled.match(resultAction)) {
      dispatch(fetchKinds({ params: { app_id: kind.app_id, target: kind.target } }));
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyKind.rejected.match(resultAction)) {
      const error = Array.isArray(resultAction.payload) ? resultAction.payload[0] : resultAction.error.message;
      message.error(error);
    }
  }

  if (!kind) {
    return null;
  }

  return (
    <ListVertical.Item
      key={kind.id}
      active={kind.id === activeId}
      image={kind.thumbnail_url}
      options={{
        options,
        placement: 'leftTop'
      }}
    >
      {kind.name}
    </ListVertical.Item>
  )
}

export default _ListItem;
